import React, { useEffect, useRef } from 'react';
import styles from './Me.module.css';
import natalie from "../../images/נטלי שוורץ תמונה ראשית.webp";

const AboutMe = () => {
  const containerRef = useRef(null);

  const handleButtonClick = () => {
    const phoneNumber = "+972508727802";
    const message = "היי נטלי, הגעתי מהדף שלך, אשמח לשמוע עוד על...";
    const encodedMessage = encodeURIComponent(message);
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappURL, "_blank");
  };

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = "1";
            entry.target.style.transform = "translateY(0)";
          }
        });
      },
      { threshold: 0.2 }
    );

    const revealElements = containerRef.current.querySelectorAll(`.${styles.revealItem}`);
    revealElements.forEach(el => {
      el.style.opacity = "0";
      el.style.transform = "translateY(20px)";
      el.style.transition = "opacity 1s ease, transform 1s ease";
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={containerRef} className={styles.section} id="מי-אני">
      <div className={styles.container}>
        <div className={`${styles.imageWrapper} ${styles.revealItem}`}>
          <img src={natalie} alt="נטלי שוורץ" className={styles.image} />
        </div>

        <div className={`${styles.content} ${styles.revealItem}`}>
          <h2 className={styles.mainTitle}>נעים מאוד, נטלי שוורץ</h2>
          <div className={styles.subtitle}>מנהלת סושיאל ויוצרת תוכן לעסקים כבר מעל 5 שנים</div>

          <div className={styles.textBlock}>
            <p className={styles.paragraph}>
              מאז שאני זוכרת את עצמי אהבתי לעצב, לצלם ולערוך, כל דבר שקשור בלגרום למשהו להיראות טוב ולשדר רגש. 
              בהתחלה עשיתי את זה בשביל הכיף ברשת מזון גדולה שעבדתי בה ולעסקים של חברים, כי אהבתי לראות איך תוכן טוב ומילים מדויקות משנות את איך שאנשים תופסים את העסק.
            </p>
            <div className={styles.divider}></div>

            <p className={styles.paragraph}>
              באיזשהו שלב ניהלתי גם את הסושיאל של מתמודדת מהאח הגדול, 
              ומשם הדברים התחילו לרוץ מהר. העסקים שניהלתי להם את הרשתות צמחו, 
              התכנים שעשיתי להם הביאו להם לקוחות והגדילו להם את הפרנסה, 
              ובעלי עסקים התחילו לפנות אליי. באותו רגע הבנתי שיש פה משהו מיוחד. 
              משהו שאני לא רק טובה בו, אלא נהנית ממנו באמת.
            </p>
            <div className={styles.divider}></div>

            <p className={styles.paragraph}>
              אחרי עצירה קטנה לתואר בתקשורת, היום אני נותנת שירותי ניהול סושיאל, יצירת תוכן, 
              ימי צילום לבעלי עסקים שרוצים תוצאות אמיתיות ומכשירה בעלי עסקים שרוצים לעשות את זה לבד בהדרכות וליווי צמוד. 
              אני יודעת לעזור לעסקים שכבר ניסו לשווק לבד והתעייפו, לעסקים שאין להם זמן, 
              ולעסקים שיודעים כמה חשוב להיראות נכון, אבל אין להם זמן לעשות את זה לבד, 
              ורוצים שמישהי תנהל את זה עבורם בצורה מקצועית, עקבית ומדויקת.
            </p>
            <div className={styles.divider}></div>

            <p className={styles.finalText}>
              אני מאמינה ששיווק טוב לא צריך להיות מסובך. 
              הוא צריך להיות מותאם אישית אלייך, עקבי ונכון. 
              כשיש סדר, תכנון והבנה של הקהל שלך, השיווק עובד, 
              והעסק שלך מתחיל למשוך את האנשים הנכונים בלי לרדוף אחריהם.
            </p>
          </div>

          <button className={styles.ctaButton} onClick={handleButtonClick}>
            <span className={styles.buttonIcon}>💬</span>
            הדרך שלנו מתחילה בלחיצה כאן
          </button>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;